import { apiRequest } from '../../../helpers/apiRequest/apiRequest';
import { LOGOUT_URL } from '../../../constants/ROUTECONSTANTS';
import { rollbar, logErrorFromPromise } from '../../../components/RollbarConfig/RollbarConfig';
import { NOTIFICATION_TYPE, SOMETHING_WENT_WRONG, ENCOUNTER_RESULT } from '../../../constants/CONSTANTS';

/**
 * To get Student Level Info
 * @param {string} userId
 * @param {context} notificationContext
 * @param {context} loaderContext
 * @returns
 */
export const getStudentLevelInfo = async (userId, notificationContext, loaderContext) => {
  loaderContext.enableLoader(true);
  const url = `${process.env.REACT_APP_LS_API_URL}v2/users/${userId}/state?fields=studentLevelInfo`;
  return apiRequest('GET', url).then((response) => {
    loaderContext.enableLoader(false);
    if (response && response.status === 401) {
      localStorage.clear();
      window.location.href = LOGOUT_URL;
    }
    if (response && response.status === 400) {
      notificationContext.setNotificationState({
        type: NOTIFICATION_TYPE.ATTENTION,
        title: SOMETHING_WENT_WRONG,
        message: ''
      });
      logErrorFromPromise(response.json());
    }
    return response.json();
  })
    .catch((response) => {
      loaderContext.enableLoader(false);
      notificationContext.setNotificationState({
        type: NOTIFICATION_TYPE.ATTENTION,
        title: SOMETHING_WENT_WRONG,
        message: ''
      });
      rollbar.error(response);
    });
};

export const getUnitSummaries = async (userId) => {
  const apiUrl = `${process.env.REACT_APP_LS_API_URL}students/${userId}/unitssummaries`;
  return apiRequest('GET', apiUrl).then((response) => {
    if (response && response.status === 401) {
      localStorage.clear();
      window.location.href = LOGOUT_URL;
    }
    if (response && response.status === 400) {
      logErrorFromPromise(response.json());
    }
    return response.json();
  })
    .catch((response) => {
      rollbar.error(response);
    });
}

export const getStudentUpcomingClasses = async (userId) => {
  const apiUrl = `${process.env.REACT_APP_LS_API_URL}v2/users/${userId}/upcomingClasses`;
  try {
    const response = await apiRequest('GET', apiUrl);
    if (response && response.status === 401) {
      localStorage.clear();
      window.location.href = LOGOUT_URL;
      return;
    }
    if (response && response.status === 400) {
      const errorData = await response.json();
      logErrorFromPromise(errorData);
      return errorData;
    }
    return await response.json();
  } catch (error) {
    rollbar.error(error);
    return null;
  }
};

export const checkUnitEncounterReadiness = async (studentId, currentUnitNumber) => {
  const unitSummaryDetails = await getUnitSummaries(studentId);
  return unitSummaryDetails?.elements?.find((unitDetail) => 
    Number(unitDetail?.unitNumber) === currentUnitNumber &&
    unitDetail?.activitySummary?.progress === 100 &&
    unitDetail?.workbookSummary?.progress === 100 &&
    unitDetail?.encounterSummary?.result !== ENCOUNTER_RESULT.CONTINUE
  );
};
